module.exports = "/_next/static/images/AggregationProfileAPI@2x-78ff64e24a18c79178d1be914bcbe08f.webp";